import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { createRouteCreator } from '@occc-app/routes/CampaignComponents/utils';

import { FormContainerProps } from '../types';

type CampaignChangeFormValues = {
  campaign?: {
    uuid?: string;
  };
};

export const useRedirectOnCampaignChange = ({
  campaignId,
  offerId,
  type,
}: Pick<FormContainerProps, 'campaignId' | 'offerId' | 'type'>) => {
  const navigate = useNavigate();

  return useCallback(
    (values: CampaignChangeFormValues) => {
      const newCampaignUuid = values.campaign?.uuid;

      if (!newCampaignUuid || !campaignId || newCampaignUuid === campaignId) {
        return;
      }

      const routeCreator = createRouteCreator(type);
      navigate(routeCreator.updateWithTab(newCampaignUuid, offerId), { replace: true });
    },
    [campaignId, navigate, offerId, type],
  );
};
